import { Action } from 'redux'
import { RoomActions } from '../../../reducers/bookingCalendar/actionNames'
import { IRoom } from '../../../models/Room'

const sortRooms = (prevRoom, nextRoom): ISortRooms => ({
  nextRoom,
  prevRoom,
  type: RoomActions.SortRooms,
})

export interface ISortRooms extends Action<RoomActions.SortRooms> {
  prevRoom: IRoom
  nextRoom: IRoom
}

const roomsWasSorted = (room): IRoomsWasSorted => ({
  room,
  type: RoomActions.RoomsWasSorted,
})

export interface IRoomsWasSorted extends Action<RoomActions.RoomsWasSorted> {
  room: IRoom
}

const roomsSortRejected = (): IRoomsSortRejected => ({
  type: RoomActions.RoomsSortRejected,
})

export type IRoomsSortRejected = Action<RoomActions.RoomsSortRejected>

export { sortRooms, roomsWasSorted, roomsSortRejected }
